import { render, staticRenderFns } from "./PlantUploadAvatar.vue?vue&type=template&id=b01ecfce"
import script from "./PlantUploadAvatar.vue?vue&type=script&lang=ts"
export * from "./PlantUploadAvatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports